import React from 'react'
import queryString from 'qs'
import flowRight from 'lodash/flowRight'
import styled from 'styled-components'

import useQuery from 'shared/hooks/useQuery'
import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import { ConfirmationType } from 'shared/components/Notes/models/confirmation'
import TextField, { FieldLabel } from 'shared/components/TextField'
import Button from 'shared/components/Button'
import Box from 'shared/components/Box'
import { permissionSelector, roleSelector, authSelector } from 'shared/hocs/withAuth'
import { useDispatch, useSelector } from 'react-redux'

import { UserRoleTypeWithStatus } from 'pages/UserRole/model/role'
import Avatar from 'pages/Parent/components/Avatar'

type Props = WrappedProps<ConfirmationType> & {
  label?: string
  description?: string
}

function UnflagDialog(props: Props) {
  const { formState, formHandlers, onClose, onContinue, isProcessing, description, label } = props
  const { fields, errors } = formState
  const { onElementChange, onChange } = formHandlers
  const { auth: user } = useSelector(authSelector)

  return (
    <UnflagDialogBodyContainer className="confirm-dialog-container">
      {description && (
        <Box className="description">{description}</Box>
      )}
      <Box>
        <FieldLabel>{label}</FieldLabel>
        <CommentInputContainer>
          <Avatar imageURL={`${user?.photo_url}`} />
          <StyledTextField
            id="message"
            placeholder="Write your message here"
            maxRows={2}
            rows={1}
            value={fields?.message}
            onChange={onElementChange}
            error={Boolean(errors.message)}
            errorText={errors.message}
            disabled={false}
          />
        </CommentInputContainer>
      </Box>
      <StyledButton
        disabled={!fields?.message?.length}
        variant="primary"
        onClick={() => {
          if (isProcessing)
            return

          if (fields?.message?.length)
            onContinue()
        }}
      >
        {isProcessing && (
          <div className="spinner" />
        )} Unflag Members
      </StyledButton>
      <div className="dialog-button-close" onClick={onClose}>Cancel</div>
    </UnflagDialogBodyContainer>
  )
}

const WrappedUnflagDialog = flowRight(withDialog())(UnflagDialog)

const StyledTextField = styled(TextField)<{ id?: string}>`
  width: 100%;

  ${({ id }) => `
    textarea#${id} {
      padding: 16px 54px 16px 16px;
    }
  `}
`

const StyledButton = styled(Button)`
  padding: 1rem 1.5rem;
  margin: 40px auto 0;

  .spinner {
    margin-right: 10px;
  }
`

const CommentInputContainer = styled(Box)`
  position: relative;
  display: flex;
  align-items: flex-start;

  .avatar-container {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;

    margin-right: 16px;
    margin-top: 8px;
  }
`

const UnflagDialogBodyContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  padding: 40px;
  width: 100%;
  max-width: 540px;

  .description {
    width: 100%;
    margin-bottom: 40px;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  .dialog-button-close {
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;

    color: ${({ theme }) => theme?.colors?.main};
    text-decoration-line: underline;
    text-align: center;
    cursor: pointer;

    width: fit-content;
    margin: 40px auto 0;
  }
`

WrappedUnflagDialog.defaultProps = {
  // continueIsDisabled(data: UnflagDialogForm) {
  //   return !data.confirm
  // },
}

export default WrappedUnflagDialog
